module.exports = __webpack_public_path__ + "img/logan1.23c26c27.jpg";